import { usePhoneNavInPaneHeader } from 'src/components/Navbar/use-phone-nav-in-pane-header';
import { useGlobalStore } from 'src/store';
import { useScreenDimensions } from 'src/utils/system';

/**
 * Whether `DrawerCloseControl` shows a button. Without one it renders an empty box that still
 * takes a gap in a spaced row, so a layout that minds the gap can leave the control out.
 */
export const useHasDrawerControl = () => {
  const navbar = useGlobalStore.use.navbar();
  const { isMobile } = useScreenDimensions();
  const isNavInPaneHeader = usePhoneNavInPaneHeader();

  return isMobile ? isNavInPaneHeader : !navbar.isOpen;
};
